import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-action',
  templateUrl: './confirm-action.component.html',
  styleUrls: ['./confirm-action.component.css'],
  standalone: false
})
export class ConfirmActionComponent implements OnInit {
  constructor(

    public dialogRef: MatDialogRef<ConfirmActionComponent>,

    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  get title(): string {
    return this.dialogData?.title ?? '';
  }

  get body(): any {
    return this.dialogData?.body ?? null;
  }

  get confirmText(): string {
    return this.dialogData?.confirmText ?? '';
  }

  get onConfirm(): Function {
    return this.dialogData?.onConfirm ?? (() => {});
  }

  get onCancel(): Function {
    return this.dialogData?.onCancel ?? (() => {});
  }

  get lottieIconPath(): string {
    return this.dialogData?.lottieIconPath ?? '';
  }

  get showConfirmButton(): boolean {
    return this.dialogData?.showConfirmButton ?? false;
  }

  get showCancelButton(): boolean {
    return this.dialogData?.showCancelButton ?? false;
  }

  ngOnInit(): void {

  }

  cancel() {
    this.dialogRef.close();
    this.onCancel();
  }

  confirm() {
    this.onConfirm();
    this.dialogRef.close();
  }
}
